var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.caseActivityDetails.id)?_c('div',[_c('v-icon',[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_vm._v(" "+_vm._s(_vm.label)+" on "+_vm._s(_vm.eventDate)+". ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }